import { Formik, Form } from 'formik';
import * as yup from 'yup';
import { Button, Input, Spinner } from '@crazyegginc/hatch';

import { Modal } from '/src/contexts/modal';

const validationSchema = yup.object().shape({
  regenerate: yup
    .string()
    .required('required')
    .matches(/^REGENERATE$/, 'must match'),
});

export function RegenerateTrackingModal({ onRegenerate = null, text, onCancel }) {
  return (
    <Modal>
      <Modal.Title className="!mb-[15px]">Are you sure?</Modal.Title>

      <Formik
        initialValues={{ regenerate: '' }}
        validationSchema={validationSchema}
        onSubmit={async (values) => {
          await onRegenerate?.(values.regenerate.toLowerCase());
        }}
      >
        {({ values, errors, touched, handleChange, handleBlur, setFieldTouched, isSubmitting }) => (
          <Form>
            <div className="text-body-2 leading-normal">
              <p className="mb-[25px]">{text}</p>
              <Input
                name="regenerate"
                id="regenerate-confirm-input"
                label="Type REGENERATE below to confirm:"
                placeholder="Type REGENERATE to continue"
                onFocus={() => setFieldTouched('regenerate', true, true)}
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.regenerate}
                autoComplete="off"
              />
              <span className="text-caption">case sensitive</span>
            </div>

            <Modal.Actions>
              <Button
                disabled={!!errors.regenerate || !touched.regenerate || isSubmitting}
                type="submit"
                className="!flex !items-center !justify-center !space-x-2.5"
              >
                {isSubmitting ? (
                  <>
                    <Spinner />
                    <span>Regenerating API Key...</span>
                  </>
                ) : (
                  `Regenerate API Key`
                )}
              </Button>
              <Modal.Cancel disabled={isSubmitting} onClick={onCancel} />
            </Modal.Actions>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}
